import { observable } from "mobx";
import CommonActions from "./actions";
import { Utils } from "arv-reactcomponents";

class CommonStoreClass extends CommonActions {
  constructor(props) {
    super(props);
    this.isBrandPageTemp = (props && props.isBrandPage) || false;
    this.brandDetailsTemp = (props && props.brandDetails) || {};
  }
  @observable isBrandPage = this.isBrandPageTemp;
  @observable brandDetails = this.brandDetailsTemp;
  @observable
  guestCartSkuIdsList = Utils.localStorage.getItem("cart-guest") || [];
  @observable cartItems = [];
}

// const CommonStoreConst = new CommonStoreClass();

export default CommonStoreClass;
// export { CommonStoreClass };



// WEBPACK FOOTER //
// ./src/stores/CommonStore/index.js